export const workloadConstants = {
    errors: {
        fetchFailed: "Failed to load workload data.",
        genericError: "Something went wrong.",
    },
};
